//import logo from './logo.svg';
import React, {useState} from "react";
import './App.css';
import Container from 'react-bootstrap/Container';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { BrowserRouter as Router, Routes, Route, NavLink } from "react-router-dom";
import HomePage from './components/Home';
import AboutUs from './components/AboutUs';
import ContactUs from './components/ContactUs';
import FooterCont from './components/Footer';
import logo from './assests/sri_amman_associate.png';
import config from './config';

function Header({lang, setStateLang, curPage, setCurPage }) {
  return (
    <header className="py-1 shadow-lg bg-light">
      <div className="section">
          <div className="row">
            <div className="col-md-5 px-10">
              <img
                className="d-block logo-text ms-3"
                src={logo}
                alt="Sri Amman Consultants"
              />
            </div>
            <div className="col-md-7">
              <Navigation lang={lang} setStateLang={setStateLang} curPage={curPage} setCurPage={setCurPage} />
            </div>
          </div>
        
      </div>
    </header>
  );
}

function Navigation({lang, setStateLang, curPage, setCurPage }) {
  const setLang = (eventKey) => {
    // console.log("Selected:", eventKey);
    setStateLang(eventKey);

    const elements = document.querySelectorAll(".dcont");
    elements.forEach((el) => {
      const elfor = el.getAttribute('name');
      //console.log(el.id)
      //console.log(elfor)
      //console.log(curPage)
      
      if(elfor===undefined || elfor===null)
        el.innerHTML = config.pg_content[curPage][el.id][eventKey];
      else
        el.innerHTML = config.pg_content[curPage][el.id][elfor][eventKey];
    });
    
    if(curPage === "home"){
      document.getElementById("expTitle").innerHTML=config.pg_content.home["con7"]["title"][eventKey];
      document.getElementById("expDesc").innerHTML=config.pg_content.home["con7"]["desc"][eventKey];
    }
  };

  const setPage=(eventKey) => {
    setCurPage(eventKey);
    // console.log(eventKey);
  };

  return (
    <Navbar expand="lg" className="bg-body-tertiary">
      <Container>
        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">
          <Nav id="top-menu" className="me-auto" activeKey="/" onSelect={setPage}>
            <Nav.Link as={NavLink} eventKey="home" to="/" href="/">{ config.pg_content.nav["home"][lang] }</Nav.Link>
            <Nav.Link as={NavLink} eventKey="about" to="/about" href="/about">{ config.pg_content.nav["aboutus"][lang] }</Nav.Link>
            <Nav.Link as={NavLink} eventKey="contact" to="/contact" href="/contact">{ config.pg_content.nav["contactus"][lang] }</Nav.Link>
            {/* <NavDropdown title="Dropdown" id="basic-nav-dropdown">
              <NavDropdown.Item href="#action/3.1">Action</NavDropdown.Item>
              <NavDropdown.Item href="#action/3.2">
                Another action
              </NavDropdown.Item>
              <NavDropdown.Item href="#action/3.3">Something</NavDropdown.Item>
              <NavDropdown.Divider />
              <NavDropdown.Item href="#action/3.4">
                Separated link
              </NavDropdown.Item>
            </NavDropdown> */}
          </Nav>
          <Nav className="mr-20 justify-content-end" activeKey={lang}>
              <NavDropdown align="end" title={ config[lang] } onSelect={setLang} id="basic-nav-dropdown">
                <NavDropdown.Item eventKey="en">{ config["en"] }</NavDropdown.Item>
                <NavDropdown.Item eventKey="tl">{ config["tl"] }</NavDropdown.Item>
              </NavDropdown>
          </Nav>

        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

function App() {
  const currentLocation = window.location.pathname
  const path=currentLocation.split('/')
  const lpath=path[path.length-1]
  const [lang, setStateLang] = useState(config.lang);
  const [curPage, setCurPage] = useState(lpath==="" ? "home" : lpath);

  return (
    <Router>
      <Header lang={lang} setStateLang={setStateLang} curPage={curPage} setCurPage={setCurPage} />
      <main>
        <Routes>
          <Route path="/" element={<HomePage lang={lang} setStateLang={setStateLang} curPage={curPage} setCurPage={setCurPage} />} />
          <Route path="/about" element={<AboutUs lang={lang} setStateLang={setStateLang} curPage={curPage} setCurPage={setCurPage} />} />
          <Route path="/contact" element={<ContactUs lang={lang} setStateLang={setStateLang} curPage={curPage} setCurPage={setCurPage} />} />
        </Routes>
      </main>
      <FooterCont />
    </Router>
  );
}

export default App;
